import { Header, SignInButton } from '@amzn/awscat-react-components';
import { AuthContextInterface, withAuthContext } from '@amzn/awscat-react-components';
import { useLocation } from 'react-router-dom';

import { constants } from './common/Localization';
import FeedbackDropdown from './components/common/FeedbackDropdown';
import HeaderUserName from './components/common/HeaderUserName';
import Notifications from './components/common/Notifications';
import RecentPortfoliosList from './components/common/RecentPortfolios';
import ResourcesDropdown from './components/common/ResourcesDropdown';
 
 type AppHeaderProps = AuthContextInterface & {isAuthenticated: boolean, title: string};
 
const AppHeader = (props: AppHeaderProps) => {
    const location = useLocation();
 
    let header: JSX.Element;
    if (props.isAuthenticated && location.pathname !== '/signin') {
        if (location.pathname === '/') {
            header = (
                <Header title={props.title}>
                    <li className='dropdown'><FeedbackDropdown buttonText={constants.FEEDBACK} /></li>
                    <li className='separated vertical-line'></li>
                    <li className='dropdown'><ResourcesDropdown isAuthenticated={props.isAuthenticated} /></li>
                    <li className='separated'><HeaderUserName isAuthenticated={props.isAuthenticated} /></li>
                    <li className='separated'><SignInButton isAuthenticated={props.isAuthenticated} /></li>
                </Header>
            );
        } else {
            header = (
                <Header title={props.title}>
                    <li className='notification'><Notifications isAuthenticated={props.isAuthenticated}/></li>
                    <li className='dropdown'><FeedbackDropdown buttonText={constants.FEEDBACK} /></li>
                    <li className='separated vertical-line'></li>
                    <li className='dropdown'><ResourcesDropdown isAuthenticated={props.isAuthenticated} /></li>
                    <li className='separated'><HeaderUserName isAuthenticated={props.isAuthenticated} /></li>
                    <li className='separated'><SignInButton isAuthenticated={props.isAuthenticated} /></li>
                    <li className='dropdown separated recent-portfolios'><RecentPortfoliosList showWhileLoading={true}/></li>
                </Header>
            );
        }
    } else {
        header = (
            <Header title={props.title}>
                <li><SignInButton isAuthenticated={props.isAuthenticated} /></li>
            </Header>
        );
    }
 
    return header;
};
 
export default withAuthContext(AppHeader);
